import { render, staticRenderFns } from "./cancelQuotaStake.vue?vue&type=template&id=f2c2aab0&"
import script from "./cancelQuotaStake.vue?vue&type=script&lang=js&"
export * from "./cancelQuotaStake.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f2c2aab0')) {
      api.createRecord('f2c2aab0', component.options)
    } else {
      api.reload('f2c2aab0', component.options)
    }
    module.hot.accept("./cancelQuotaStake.vue?vue&type=template&id=f2c2aab0&", function () {
      api.rerender('f2c2aab0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/quota/cancelQuotaStake.vue"
export default component.exports